<div
  class="reaction-selection"
  tuiDropdownAlign="right"
  [tuiDropdown]="emojiListTmp"
  [(tuiDropdownOpen)]="emojiListOpened"
>
  <app-emoji
    *ngFor="let reaction of frequentlyReactions"
    [emojiName]="reaction"
    (clicked)="onClickReaction($event)"
  ></app-emoji>

  <button tuiIconButton type="button" iconStart="@tui.chevron-down" [appearance]="'icon'" [size]="'s'"></button>
</div>

<ng-template #emojiListTmp>
  <app-emoji-list (emojiClicked)="onClickReaction($event)"></app-emoji-list>
</ng-template>
